import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useActivateClientCardMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url,
      }),
  });

export const useUseClientCardMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { location_id: number; specialist_id?: number };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });

export const useUseClientCardDiscountMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: {
        location_id: number;
        client_card_discount_id: number;
        specialist_id?: number;
      };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });
